/**
 * Handles Escape before a surrounding Radix dialog closes. Radix listens in the
 * capture phase on `document`; `window` precedes it in the capture path.
 */
export const listenEscapeFirst = (handler: () => void) => {
  const listener = (event: KeyboardEvent) => {
    if (event.key !== "Escape") return;
    event.stopImmediatePropagation();
    event.preventDefault();
    handler();
  };
  window.addEventListener("keydown", listener, true);
  return () => window.removeEventListener("keydown", listener, true);
};
